// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getFreeDrugRuleLayout = (stateName) => `<div class="drug-rules-container">
      State:
     <span class="drug-rules-answer">
      ${stateName || '--'}
      </span> 
      <div class="drug-rules-statement">
       Drug Screening Requirements:
      <span class="drug-rules-answer">
      Regular drug screen not required by state
      </span>
        </div>
     </div>`
